export default "__VITE_ASSET__BCODtiTe__"